/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { filiationInconnueAutorisee } from '@/constants';

import { validationInformationsNaissance } from '..';

/**
 * Validation de l'étape 2 « Parents ».
 *
 * Chaque parent est validé via la validation réutilisable de l'état civil ; un
 * parent déclaré inconnu / décédé (`filiationInconnueParentN`) n'est pas contrôlé.
 * La date de naissance de l'enfant (à plat dans `data`) sert au contrôle d'âge.
 *
 * ⚠️ Exception propre à la reconnaissance : un parent **auteur** de l'acte
 * reconnaît l'enfant, il est donc nécessairement identifié. Son drapeau
 * « inconnu » est ignoré, si bien que son état civil reste exigé — et sur
 * « le père et la mère », aucun des deux ne peut être inconnu
 * (cf. `constants/auteurReconnaissance`, adossé aux 2314 actes de référence).
 *
 * Sans effet sur un acte de naissance, qui n'a pas d'auteur de reconnaissance :
 * `codeAuteurReconnaissance` y est absent, aucun parent n'est alors contraint.
 *
 * Les erreurs sont regroupées par parent (`parent1` / `parent2`), clés = `name`
 * des champs sans préfixe, ce qu'attend le ParentForm de la lib.
 */
const validationStep2 = (data: Record<string, any>) => {
  /** Date de naissance de l'enfant, pour le contrôle « parent né avant l'enfant » */
  const dateNaissanceEnfant = {
    anneeNaissance: data?.anneeNaissance,
    moisNaissance: data?.moisNaissance,
    jourNaissance: data?.jourNaissance,
  };

  /** Le drapeau « inconnu » n'est retenu que si ce parent n'est pas auteur. */
  const inconnu = (numeroParent: 1 | 2) =>
    filiationInconnueAutorisee(numeroParent, data?.codeAuteurReconnaissance) &&
    Boolean(data?.[`filiationInconnueParent${numeroParent}`]);

  return _.pickBy(
    {
      parent1: validationInformationsNaissance(
        data?.parent1 ?? {},
        true,
        inconnu(1),
        dateNaissanceEnfant,
      ),
      parent2: validationInformationsNaissance(
        data?.parent2 ?? {},
        true,
        inconnu(2),
        dateNaissanceEnfant,
      ),
    },
    (v) => !_.isNil(v) && !_.isEmpty(v),
  );
};

export default validationStep2;
